import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReportData, { AdminReportType } from 'services/dataService/ReportData';
import * as userReportJSON from 'constants/JSONConstants/user-report-table-columns';
import {
  ReportCompanyUsersToolbar,
  ReportCompanyUsersList,
} from 'views/Reports/UsersCompanies/components';
import { useStyles } from './styles';
import { CustomFieldsData } from 'services/dataService';

export default () => {
  const classes = useStyles();
  const [fields, setFields] = useState([]);
  const { t } = useTranslation(['tables']);
  const [loading, setLoading] = useState(true);

  // Load table columns
  const loadFields = async () => {
    try {
      const { data: reportFields } = await ReportData.getReportFields(
        AdminReportType.USERS
      );

      const { data: customFields } = await CustomFieldsData.getCustomFields();
      const customfieldsArray = JSON.parse(customFields?.custom_fields || '[]');

      let reportData = [];
      let serverText = false;

      if (reportFields?.table_titles?.length) {
        // API user JSON
        reportData = reportFields?.table_titles;
      } else {
        // use Local JSON
        reportData = userReportJSON.default;
        reportData = reportData.concat(
          customfieldsArray?.map((field) => {
            return {
              title: field?.fieldName,
              field: field?.fieldName,
              type: field?.type,
              selected: false,
            };
          }) || []
        );
      }

      setFields(
        reportData.map(({ title, field, selected, type }) => {
          return {
            title: serverText ? title : t(title),
            field,
            type,
            hidden: !selected,
          };
        })
      );
    } catch (error) {
      setFields(
        userReportJSON.default.map(({ title, field, selected }) => {
          return { title: t(title), field, hidden: !selected };
        })
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFields();
  }, []);

  return (
    <div className={classes.root}>
      {!loading && (
        <>
          <ReportCompanyUsersToolbar
            fields={fields}
            onSave={async (selectedList) => {
              await ReportData.updateFields({
                type: AdminReportType.USERS,
                table_titles: selectedList,
              });

              loadFields();
            }}
          />
          <div className={classes.content}>
            <ReportCompanyUsersList fields={fields} />
          </div>
        </>
      )}
    </div>
  );
};
